var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('div',{staticClass:"flex-centerize width-100 height-100"},[(_vm.isError)?_c('Row',[_c('AppIcon',{staticClass:"mr-2",attrs:{"name":"info"}}),_vm._v(_vm._s(_vm.errorMessage))],1):_c('span',[_vm._v("SSO - Logging in, hold on please.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }